import { createContext, FC, ReactNode, useContext, useState } from 'react';
import { useStore } from 'zustand';

import {
  createPatientAddFormDataStore,
  PatientAddFormDataState,
  PatientAddFormDataStoreApi,
} from '../stores/createPatientAddFormDataStore';

/**
 * 환자 추가 폼 store를 하위 트리에 주입한다.
 * - store를 주면(소유 컴포넌트가 orgId/token 등으로 생성) 그 인스턴스를 그대로 공유
 * - 안 주면 내부에서 새로 생성
 */
const PatientAddFormContext = createContext<PatientAddFormDataStoreApi | null>(null);

export const PatientAddFormProvider: FC<{ store?: PatientAddFormDataStoreApi; children: ReactNode }> = ({
  store,
  children,
}) => {
  // store를 주면 그 인스턴스를 그대로 공유(소유 컴포넌트가 리셋 시 새 인스턴스를 넘길 수 있음).
  // 안 주면 내부에서 한 번 생성해 유지한다.
  const [fallback] = useState(() => createPatientAddFormDataStore(0, false));
  return <PatientAddFormContext.Provider value={store ?? fallback}>{children}</PatientAddFormContext.Provider>;
};

export function usePatientAddFormStore<U>(selector: (s: PatientAddFormDataState) => U): U {
  const store = useContext(PatientAddFormContext);
  if (!store) {
    throw new Error('usePatientAddFormStore must be used within PatientAddFormProvider');
  }
  return useStore(store, selector);
}
